import React, { useContext, useState, useEffect, useRef } from "react";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import Footer from "../../examples/Footer";
import { AuthContext } from "../../context/authcontext/AuthContext";
import { ChatContext } from "../../context/chatcontext/chatcontext";
// import SendIcon from "@mui/icons-material/Send";
import Profile from "./Image/Profile.png";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import { IconButton, Skeleton, Stack,styled } from "@mui/material";
import {
  AttachFile as AttachFileIcon,
  Send as SendIcon,
} from "@mui/icons-material";
const InputBox = styled("input")`
  width: 100%;
  height: 100%;
  border: none;
  outline: none;
  padding: 0 3rem;
  border-radius: 1.5rem;
  background-color: 'white';
`;
function ChatMain() {
  const { user: admin } = useContext(AuthContext); // Assuming the current user is the admin
  const { socket, messages } = useContext(ChatContext);
  const [currentUser, setCurrentUser] = useState(); // The user admin selects to chat with
  const [users, setUsers] = useState([]); // List of users for admin to select and chat
  const [message, setMessage] = useState("");
  const messagesEndRef = useRef(null);
  const [chatmessages,setChatMessages] = useState([]);


  useEffect(() => {
    fetchChatUsers();
    
  
   

  
  }, []);

  const fetchChatUsers = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/users/getAllUsers`);
      setUsers(response.data.data);

      return response.data;
    } catch (error) {
      console.log(error);
    }
  };
  const fetchUserAllChat=async(from,to)=>{
    try{
      const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/chat/getChats?from=${from}&to=${to}`);
      // setUsers(response.data.data);
      setChatMessages(response.data.data);
      console.log(response.data.data,'REEEESSS');
      return response.data;

    }
    catch(error){
      console.log(error);
    }
  }

  const handleChatPage = async(user) => {
   await setCurrentUser(user);
    console.log(JSON.parse(localStorage.getItem('jumunona-admin')).id,"UUUUUSSSSSSSS");

    // fetchUserAllChat(JSON.parse(localStorage.getItem('jumunona-admin')).id,user._id);
    const interval=setInterval(()=>fetchUserAllChat(JSON.parse(localStorage.getItem('jumunona-admin')).id,user._id),15000);
    return ()=> clearInterval(interval);
  };

  const handleSendMessage = (e) => {
    e.preventDefault();
    if (message.trim() && currentUser) {
      const newMessage = {
        text: message,
        senderId: admin.id,
        receiverId: currentUser._id,
        timestamp: new Date(),
      };

      setMessage("");

      socket.emit("send-msg", newMessage);
      
    }
  };
  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  // <DashboardLayout>
  //   <main className="p-2 mt-2" style={{ display: "flex" }}>
  //     {/* Users List */}
  //     <aside style={{ marginRight: "20px" }}>
  //       <h3>Users</h3>
  //       {users.map((user) => (
  //         <div key={user.id} onClick={() => setCurrentUser(user)} style={{ cursor: "pointer", marginBottom: "10px" }}>
  //           {user.name}
  //         </div>
  //       ))}
  //     </aside>

  //     {/* Chat section */}
  //     <section>
  //       <h3>Chat</h3>
  //       {/* Chat messages display */}
  //       <div style={{ marginBottom: "20px" }}>
  //         {messages.map((msg, index) => (
  //           <div key={index}>
  //             {msg.text}
  //           </div>
  //         ))}
  //         <div ref={messagesEndRef} />
  //       </div>

  //       {/* Input and send button */}
  //       {currentUser && (
  //         <div>
  //           <input
  //             type="text"
  //             placeholder="Type a message"
  //             value={message}
  //             onChange={(e) => setMessage(e.target.value)}
  //             style={{ marginRight: "10px" }}
  //           />
  //           <button onClick={handleSendMessage}><SendIcon /></button>
  //         </div>
  //       )}
  //     </section>
  //   </main>
  //   <Footer />
  // </DashboardLayout>
  return (
    <DashboardLayout>
      {/* <DashboardNavbar /> */}
      <main className="p-2 mt-2">
        <section className="flex gap-[0.8px] p-4 items-center">
          {/* scrollable chat list */}
          <div className="flex flex-col gap-3">
            <h5 className=""> All Chats</h5>
            <div className="flex flex-col gap-3 bg-gray-300 p-4 h-[84vh] no-scrollbar overflow-scroll w-[15vw] rounded-md">
              <div>
                {/* <input
                type="text"
                placeholder="Search customer name"
                value={searchQuery}
                onChange={handleSearchChange}
                style={{
                  width: "210px",
                  marginLeft: "1%",
                  borderRadius: "7px",
                  padding: "5px",
                }}
              /> */}
              </div>
              {users?.map((user) => {
                return (
                  <span
                    className="bg-gray-200 text-sm cursor-pointer p-2 rounded-md text-black flex items-center"
                    onClick={() => handleChatPage(user)}
                  >
                    <img
                      src={user?.profileImage ? user?.profileImage : Profile}
                      alt="Profile"
                      style={{ width: "20%", marginRight: "10px" }}
                    />
                    <div
                      style={{
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        position: "relative",
                      }}
                    >
                      {user.userName}
                      <br />
                      <span>Text here</span>
                      {/* <img src={Dot} alt="Dot" style={{ width: "10%", marginLeft: "15px" }} /> */}
                    </div>
                  </span>
                );
              })}
            </div>
          </div>

          {/* messages layout */}
          <div className="flex flex-col gap-3" style={{ height: "90vh" }}>
            {/* <h5>user</h5> */}
            <span
              style={{ marginTop: "6%" }}
              className="bg-gray-200 text-sm cursor-pointer p-2 rounded-md text-black flex items-center"
            >
              <img
                src={currentUser?.profileImage ? currentUser?.profileImage : Profile}
                alt="Profile"
                style={{ width: "10%", marginRight: "10px" }}
              />
              <div
                style={{
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {currentUser?.userName}
                <br />
                <span>Online</span>
              </div>
            </span>

            <div className="bg-gray-300 h-[86vh] overflow-scroll no-scrollbar w-[41vw] rounded-lg p-4">
              <div className="h-[55vh]  p-2 overflow-scroll no-scrollbar">
                <div className="">
                  {chatmessages.map((message, index) => (
                    <div
                      key={message.id}
                      className={`max-w-[75%] p-2 rounded-xl ${
                        message.sender === JSON.parse(localStorage.getItem('jumunona-admin')).id ? "bg-blue-400 ml-auto" : "bg-gray-100"
                      } ${index !== messages.length - 1 ? "mb-3" : ""}`}
                    >
                      {
                        message.renderCell ? (
                          message.renderCell(message)
                        ) : (
                          <span className="text-sm text-black">{message.message.text}</span>
                        )
                        // <img
                        //   src={download}
                        //   alt="download"
                        //   style={{ width: "10%", marginRight: "10px" }}
                        // />
                      }
                    </div>
                  ))}
                  <div ref={messagesEndRef}></div>
                </div>
              </div>

              {/* <div className="flex items-center gap-3">
                <div className="sendNewMessage" style={{ width: "100%", marginTop: "5%" }}>
                  <div>
                    
                    <button className="addFiles">
                      <AddIcon style={{ fontSize: "10%" }} />
                    </button>
                    
                    <input
                      type="text"
                      placeholder="Type a message here"
                      value={message}
                      style={{width: '80%'}}
                      onChange={(e) => setMessage(e.target.value)}
                    />
                    
                  </div>

                  <button className="btnSendMsg" id="sendMsgBtn" onClick={handleSendMessage}>
                    Send
                    <SendIcon style={{ fontSize: "40%" }} />
                  </button>
                </div>
              </div> */}
              <form
        style={{
          height: "10%",
        }}
        // onSubmit={submitHandler}
        onSubmit={handleSendMessage}
      >
        <Stack
          direction={"row"}
          height={"100%"}
          padding={"1rem"}
          alignItems={"center"}
          position={"relative"}
        >
          <IconButton
            sx={{
              position: "absolute",
              left: "1.5rem",
              rotate: "30deg",
            }}
            // onClick={handleFileOpen}
          >
            <AttachFileIcon />
          </IconButton>

          <InputBox
            placeholder="Type Message Here..."
            value={message}
            // onChange={messageOnChange}
            onChange={(e) => setMessage(e.target.value)}

          />

          <IconButton
            type="submit"
            sx={{
              rotate: "-30deg",
              bgcolor: '#aeb7d5',
              color: "white",
              marginLeft: "1rem",
              padding: "0.5rem",
              "&:hover": {
                bgcolor: "error.dark",
              },
            }}
          >
            <SendIcon />
          </IconButton>
        </Stack>
      </form>
              {/* display selected files */}
              {/* <DisplaySeectedFiles files={selectedFiles} /> */}
            </div>
          </div>
          <div className="flex flex-col gap-3">
            <h5 className=""> Order Detail</h5>
            <div
              className="flex flex-col gap-3 bg-gray-200 p-4 h-[86vh] no-scrollbar overflow-scroll w-[22vw] rounded-md"
              style={{ marginLeft: "2%" }}
            >
              {/* <div style={{ display: "flex", justifyContent: "center" }}>
              <img src={shoes} alt="Shoes" style={{ width: "40%" }} />
            </div> */}

              <div>
                <div style={{ fontFamily: "serif", fontSize: "20px" }}>Order No.</div>
                <div style={{ fontFamily: "serif", fontSize: "20px" }}>Name:</div>
                <div style={{ fontFamily: "serif", fontSize: "20px" }}>Price:</div>
                <div style={{ fontFamily: "serif", fontSize: "20px" }}>Varient Product</div>
                <div style={{ fontFamily: "serif", fontSize: "20px" }}>Delivery Charge</div>
                <div style={{ fontFamily: "serif", fontSize: "20px" }}>Shipped Time</div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </DashboardLayout>
  );
}

export default ChatMain;
